import { ProductQtyErrorCode } from '../../../../../generated/graphql';
import { ILabel } from '../../../models/common/label.model';
import { IPLPProduct } from '../../../models/plp/plp-products.model';
import { IPLPPricesItem } from '../../../models/plp/product-list-page.model';
import { IPricesResult } from '../../../services/pricing/pricing.dto';

export type CompareAlternativesProductHeaderProps = {
  labels: ILabel[];
  product: IPLPProduct;
  inFixedCTA?: boolean;
  isFirstProduct?: boolean;
  isLastProduct?: boolean;
};

export type State = {
  quantity: number;
  isValidQty: boolean;
  isBusy: boolean;
  isDropdownOpen: boolean;
  unlistedQuantityPrice?: string;
  isSearchingUnlistedQuantity?: boolean;
  defaultDropdownSelection?: number;
  errorMsg?: string;
  prices: IPLPPricesItem[];
  showAddConfirmationModal: boolean;
};

export enum CompareAlternativesProductHeaderActionType {
  IsBusy = 'IsBusy',
  SetPriceData = 'SetPriceData',
  ToggleDropDownOpen = 'ToggleDropDownOpen',
  SetUnlistedQuantityPrice = 'SetUnlistedQuantityPrice',
  SetInvalidUnlistedQty = 'SetInvalidUnlistedQty',
  SearchUnlistedQuantity = 'SearchUnlistedQuantity',
  SearchListedQuantity = 'SearchListedQuantity',
  CloseAddConfirmationModal = 'CloseAddConfirmationModal',
}

export type Action =
  | { type: CompareAlternativesProductHeaderActionType.IsBusy; isBusy: boolean; isSuccess?: boolean; isDropdownOpen?: boolean }
  | { type: CompareAlternativesProductHeaderActionType.SetPriceData; data: IPricesResult }
  | { type: CompareAlternativesProductHeaderActionType.ToggleDropDownOpen; isOpen: boolean }
  | { type: CompareAlternativesProductHeaderActionType.SetUnlistedQuantityPrice; qty?: number; price?: string; message?: string }
  | { type: CompareAlternativesProductHeaderActionType.SetInvalidUnlistedQty; quantity: number; errorCode: ProductQtyErrorCode }
  | { type: CompareAlternativesProductHeaderActionType.SearchUnlistedQuantity; quantity: number }
  | { type: CompareAlternativesProductHeaderActionType.SearchListedQuantity; quantity?: number }
  | { type: CompareAlternativesProductHeaderActionType.CloseAddConfirmationModal };
